import React, {useState} from "react";
import {EmployeeStatus} from "@/data/entities/employee";
import {SetStateFn} from "@/utils/SetStateUtils";
import EmployeeLogin from "@widgets/timeRegistration/unauthenticated/EmployeeLogin";
import ClockSystem from "@widgets/timeRegistration/authenticated/ClockSystem";

export type EmployeeDashboardProps = {
    setEmployee: SetStateFn<EmployeeStatus | null>,
};

type Props = {
    wrapInCard: boolean,
};

const EmployeeDashboard = ({wrapInCard}: Props) => {
    const [employee, setEmployee] = useState<EmployeeStatus | null>(null);

    if (employee === null) {
        return (
            <EmployeeLogin
                wrapInCard={wrapInCard}
                setEmployee={setEmployee}
            />
        );
    }

    return (
        <ClockSystem
            wrapInCard={wrapInCard}
            setEmployee={setEmployee}
            employee={employee}
        />
    );
};

export default EmployeeDashboard;